export default function Vid() {
  return (<svg id="XMLID_822_" xmlns="http://www.w3.org/2000/svg" width="18.55" height="13.055" viewBox="0 0 18.55 13.055">
    <path id="XMLID_823_" d="M17.827,47.038c-.67-.8-1.906-1.121-4.267-1.121H4.99c-2.415,0-3.672.346-4.339,1.193C0,47.936,0,49.154,0,50.839V54.05c0,3.264.772,4.922,4.99,4.922H13.56c2.047,0,3.182-.287,3.916-.989.753-.72,1.074-1.9,1.074-3.933V50.839C18.55,49.062,18.5,47.837,17.827,47.038Zm-5.918,5.85L8.017,54.922a.6.6,0,0,1-.876-.53V50.337a.6.6,0,0,1,.874-.531l3.892,2.021a.6.6,0,0,1,0,1.061Z" transform="translate(0 -45.917)" fill="#8e8d92" />
  </svg>)
}

